/**
* Created by lobin on 2020/7/15.
*/
<template>
  <div class="station-map">
    <div class="amap-page-container">
      <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
        <el-amap ref="map" vid="amapDemo" :amap-manager="amapManager" :zoom="zoom" class="amap-demo">
          <el-amap-marker
            vid="component-marker"
            v-for="(item,index) in list"
            :position="item.position"
            :key="index"
            :label="{content: item.name, offset:[20,2]}"
            animation="AMAP_ANIMATION_DROP"
            />
        </el-amap>
      </a-card>
    </div>
  </div>
</template>

<script type="text/babel">
import { AMapManager } from 'vue-amap';
import { stationMap } from '@/api/station';

const amapManager = new AMapManager();
export default {
  created() {
    this.getMapData();
  },
  data() {
    return {
      list: [],
      amapManager,
      zoom: 12,
    };
  },

  methods: {
    async getMapData() {
      const { data } = await stationMap();
      this.list = data;
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
.station-map {
  .amap-demo {
    height: 500px;
  }
}
</style>
